import script from "./Photo.vue?vue&type=script&setup=true&lang=js"
export * from "./Photo.vue?vue&type=script&setup=true&lang=js"

import "./Photo.vue?vue&type=style&index=0&id=052aa8f4&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052aa8f4"]])

export default __exports__